import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Button, Card, Spinner } from "react-bootstrap";
import axios from "../../../api/axios";

const InventoryDetails = ({ userLoggedIn }) => {
  const { id } = useParams();
  const [productDetails, setProductDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [lengthUnit, setLengthUnit] = useState("mm");

  const fetchInventoryDetails = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`/get-inventory/${id}`);
      setProductDetails(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching inventory details:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInventoryDetails();
  }, [id]);

  const convertTosqm = (value) => {
    // Conversion logic from MM to Inch
    return value / 1000000;
  };

  const convertTosqft = (value) => {
    // Conversion logic from MM to Inch

    const valuSqInch = value / 645.16;
    return valuSqInch / 144;
  };

  const renderArea = (value) => {
    if (typeof value !== "number") {
      return "N/A";
    }
    if (lengthUnit === "MM") {
      return convertTosqm(value).toFixed(2) + " sqM";
    } else if (lengthUnit === "Inch") {
      return convertTosqft(value).toFixed(2) + " sqFt";
    }
    return value.toFixed(2) + " mm";
  };

  if (loading) {
    return (
      <div className="text-center mt-5">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  if (!productDetails) {
    return (
      <div className="text-center mt-5">
        <h5>No details found for this inventory item.</h5>
      </div>
    );
  }

  return (
    <div className="container mt-5">
      <Card>
        <Card.Header>
          <h3>Inventory Details</h3>
        </Card.Header>
        <Card.Body>
          <h5>Product Name: {productDetails.product_name || "N/A"}</h5>
          {userLoggedIn && (
            <>
              <p>Inventory ID: {productDetails.inventory_id || "N/A"}</p>
              <p>Category: {productDetails.category_name || "N/A"}</p>
              <p>Length: {productDetails.init_slab_length || "N/A"}</p>
              <p>Width: {productDetails.init_slab_weidth || "N/A"}</p>
              <p>
                Area:{" "}
                {productDetails.init_slab_length
                  ? renderArea(
                      productDetails.init_slab_length *
                        productDetails.init_slab_weidth
                    )
                  : "N/A"}
              </p>

              <p>Quantity: {productDetails.quantity || "N/A"}</p>
              <p>
                Total Area:{" "}
                {renderArea(
                  productDetails.quantity *
                    (productDetails.init_slab_length *
                      productDetails.init_slab_weidth)
                ) || "N/A"}
              </p>

              <p>Vendor: {productDetails.vendor_name || "N/A"}</p>
              <p>Purchase ID: {productDetails.purchase_id || "N/A"}</p>
              <p>
                Date:{" "}
                {productDetails.createdAt
                  ? new Date(productDetails.createdAt).toLocaleDateString()
                  : "N/A"}
              </p>
            </>
          )}
          <Button variant="primary" onClick={() => window.history.back()}>
            Back
          </Button>
        </Card.Body>
      </Card>
    </div>
  );
};

export default InventoryDetails;
